import Resources from 'components/MapPage/CorporateViewTabs/Resources';

/**
 * Assets during initial response.
 *
 * Carries the same `dark` wrapper as the hub and the incident workspace, for
 * the reason given in `ResourcesFullPage`: Tailwind's dark variant needs a
 * `.dark` ancestor, and this page has none of its own.
 */
export const InitialResponseResources: React.FC = () => {
  return (
    <div className="dark tw:text-foreground">
      <Resources forceFullView />
    </div>
  );
};
